"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const CategoryFragment_1 = __importDefault(require("../fragments/CategoryFragment"));
const CategoryQuery = (0, graphql_tag_1.default) `
  query categoryQuery(
    $categoryId: String
    $subCategoryId: String = ""
    $storeId: String
  ) {
    category(
      categoryRequest: {
        category: $categoryId
        subcategory: $subCategoryId
        metadata: { loyaltyParams: { storeId: $storeId } }
      }
    ) {
      ...category
      subcategories {
        ...category
        subcategories {
          ...category
          subcategories {
            ...category
            subcategories {
              ...category
            }
          }
        }
      }
    }
  }
  ${CategoryFragment_1.default}
`;
exports.default = CategoryQuery;
